import { Button } from '@mui/material'
import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { COLORS } from 'src/utils/Themes/colors'
import mainImg from 'src/assets/images/Group1328.svg'
import textimg from 'src/assets/images/Group1437.svg'
import personalPolicy from 'src/assets/images/personalPolicy.svg'
import Modal from 'src/components/common/Modal'
import AddExistingPolicy from 'src/components/Individual/modals/AddExistingPolicy'

const EmptyScreenPolicies = ({ path }) => {
  const classes = useStyles()
  const [modalOpen, setModalClose] = useState(false)
  const CloseModal = () => {
    setModalClose(false)
  }
  const addPolicy = () => {
    setModalClose(true)
  }
  return (
    <div>
      {modalOpen ? (
        <Modal
          bgcolor={'#EEEEEE'}
          ordered={modalOpen}
          width={'60%'}
          left={'20%'}
          top={'14%'}
          modelClosed={CloseModal}
        >
          <AddExistingPolicy closefunction={CloseModal} path={path} />
        </Modal>
      ) : null}
      <div className={classes.emptyScreensPoliciesContainer}>
        <div className={classes.txtImgContainer}>
          <img src={textimg} alt='' />
        </div>
        <div className={classes.mainImgContainer}>
          <img src={mainImg} alt='' />
        </div>
        <div className={classes.policyUploadContainer}>
          <Button
            className={classes.buttonUploadPersonal}
            onClick={addPolicy}
            id='addPolicyButton'
          >
            Upload Personal Policies
            <img
              src={personalPolicy}
              alt=''
              className={classes.personalPoliciesImg}
            />
          </Button>
        </div>
      </div>
    </div>
  )
}

export default EmptyScreenPolicies

const useStyles = makeStyles({
  buttonUploadPersonal: {
    textTransform: 'unset',
    fontSize: '11px',
    fontWeight: '600',
    background: COLORS.WHITE,
    color: COLORS.MEDIUM_LIGHTBLUE,
    // margin: "-4px 0 10px 9px",
    height: '24px',
    padding: '15px 20px !important',
    borderRadius: '6px',
    '&:hover': {
      backgroundColor: COLORS.WHITE,
    },
    boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.15)',
  },
  emptyScreensPoliciesContainer: {
    width: '50vw',
    backgroundColor: 'white',
    borderRadius: '20px',
  },
  txtImgContainer: {
    padding: '30px 0px 25px 0px',
    textAlign: 'center',
  },
  mainImgContainer: {
    padding: '30px 0px',
    textAlign: 'center',
  },
  policyUploadContainer: {
    padding: '10px 0px 30px 0px',
    textAlign: 'center',
  },
  personalPoliciesImg: {
    width: '15px',
    paddingLeft: '5px',
  },
})
